import { UserContract } from "#/api/contracts.type";
import MedicalRecordsRequestListItem from "./MedicalRecordsRequestListItem";

interface MedicalRecordsRequestListProps {
  items: UserContract[];
}

export function MedicalRecordsRequestList({ items }: MedicalRecordsRequestListProps) {
  return (
    <ul className="divide-y divide-cream-200 rounded-xl border border-cream-200">
      {items.map((item, index) => (
        <MedicalRecordsRequestListItem key={item.id ?? item.signing?.id ?? index} request={item} index={index} />
      ))}
    </ul>
  );
}

export default MedicalRecordsRequestList;
